module.exports = "button.delete {\n\tcolor: red;\n    border: none;\n    background: none;\n}\n.form-group{\n    margin-left: 0;\n    margin-right: 0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/advanced-form-search/advanced-form-search.component.css
// module id = ./src/app/shared/advanced-form-search/advanced-form-search.component.css
// module chunks = main